import { Loader2Icon } from 'lucide-react';
import { cn } from './helpers';

function Spinner({ className, ...props }: React.ComponentProps<'svg'>) {
  return (
    <Loader2Icon
      role='status'
      aria-label='Loading'
      className={cn('size-4 animate-spin text-primary-1000', className)}
      {...props}
    />
  );
}

export { Spinner };
